import userLoggedCheckout from './checkout.js';

const users = new userLoggedCheckout();

$(".logout").click(function() {
    users.signOut();
});

$(".continue").click(function() {
    users.FechareContinuar();
});

$("#login2").click(function() {
    users.signIn();
});